import * as Material from "@mui/material";
import { IconPlus, IconSettings } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { Button } from "@fragments";

import "./styles.scss";

export default function GroupTabs({
    groups,
    currentGroupId,
    isAdmin,
    onChangeGroup,
    onCreateGroup,
    onEditGroup,
}) {
    const { t } = useTranslation("community");

    return (
        <div className="groups-tab border-sf-3 mb-4">
            <div
                className="screen-padding"
                style={{ display: "flex", alignItems: "center" }}
            >
                {isAdmin && (
                    <Button
                        tooltip={t("group.addGroup")}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onCreateGroup();
                        }}
                        icon={<IconPlus size={18} />}
                        color="overlay"
                    />
                )}
                <Material.Tabs
                    value={currentGroupId || false}
                    onChange={(_, newValue) => onChangeGroup(newValue)}
                    variant="scrollable"
                    className="groups-tabs"
                >
                    {groups?.length > 0 ? (
                        groups.map((groupItem) => (
                            <Material.Tab
                                key={groupItem.id}
                                label={
                                    <div className="group-select-input">
                                        {groupItem.banner ? (
                                            <img
                                                src={groupItem.banner}
                                                className="group-banner"
                                            />
                                        ) : (
                                            <div className="group-banner" />
                                        )}
                                        <h4 style={{ margin: 0 }} className="mr-1">
                                            {groupItem.name}
                                        </h4>
                                        {isAdmin && (
                                            <Button
                                                tooltip={t("group.configureGroup")}
                                                icon={<IconSettings size={16} />}
                                                color="overlay"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    onChangeGroup(groupItem.id);
                                                    onEditGroup(groupItem);
                                                }}
                                                style={{ marginLeft: "-8px !important" }}
                                            />
                                        )}
                                    </div>
                                }
                                value={groupItem.id}
                                className={
                                    currentGroupId === groupItem.id ? "current-tab" : ""
                                }
                            />
                        ))
                    ) : (
                        <Material.Tab
                            label={
                                <h4 style={{ margin: 0 }}>
                                    <i>{t("group.noGroups")}</i>
                                </h4>
                            }
                            value={false}
                            disabled={true}
                        />
                    )}
                </Material.Tabs>
            </div>
        </div>
    );
}
